import "./StatusChip.scss";

import cn from "classnames";
import React from "react";

import { ForecastStatus } from "@blisspointmedia/bpm-types/dist/Forecasting";

import { Button, ButtonProps, ButtonType } from "../../Components";

interface StatusChipProps extends Omit<ButtonProps, "type" | "design"> {
  status: ForecastStatus;
}

const statusToPrettyLabel = (status: ForecastStatus): string => {
  switch (status) {
    case "In Progress":
      return "Processing";
    case "Completed":
      return "Live";
    default:
      return status;
  }
};

const StatusChip = ({ status, ...buttonProps }: StatusChipProps): JSX.Element => {
  return (
    <Button
      className={cn("statusChip", `statusChip${status.replace(/\s/g, "")}`)}
      design="secondary"
      type={ButtonType.FILLED}
      {...buttonProps}
    >
      {statusToPrettyLabel(status)}
    </Button>
  );
};

export default StatusChip;
